import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Component from './component'
import Callbacks from './callbacks'

const Container = () => {
  const [dispatchJobs] = hooks.useModelFunction('job', 'dispatchMultiple')
  const submitMultipleDispatch = useCallback(Callbacks.handleSubmitMultipleDispatch(dispatchJobs), [dispatchJobs])
  const mergedProps = {
    submitMultipleDispatch,
  }
  return (
    <Component {...mergedProps} />
  )
}

export default Container
